// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonFeedBack_button__11ZAK"};